import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Cookies from 'js-cookie';
import { Col, Row } from 'react-flexbox-grid';

// CSS Modules, react-datepicker-cssmodules.css
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import './DatePicker.css';

const DynamicDatePicker = (props) => {
  const dateFormatedPlaceholder = new Date().toLocaleDateString('en-GB').replace(/\//g, '-');
  const [startDate, setStartDate] = useState(null);

  useEffect(() => {
    if (props.state[props.el.name]) {
      setStartDate(new Date(props.state[props.el.name]));
    }
  }, []);

  const onChangeEventHandler = async (date) => {
    setStartDate(date);
    props.onChangeHandler(date, props.el.name, props.el.type);
  };

  // Custom input para mostrar un icono 'x' cuando hay error
  const CustomInput = React.forwardRef(
    ({ value, onClick, onChange, placeholder, el, onClear }, ref) => {
      return (
        <div className="dp-input-wrapper dp-input-outer">
          <div className="dp-input-inner">
            <input
              ref={ref}
              value={value}
              onClick={onClick}
              onChange={onChange}
              placeholder={placeholder}
              className={`form-control ${el && el.error && !value ? 'is-invalid dp-error' : ''}`}
            />
          </div>
        </div>
      );
    }
  );

  const disableFieldBasedMethod = (el) => {
    const { userId_03 } = Cookies.get();
    if (!el.readonly) {
      if (props.mode === 2) {
        return true;
      }
      if (props.mode === 1) {
        return false;
      } else {
        if (parseInt(userId_03) !== parseInt(props.applicant)) {
          return true;
        } else {
          return false;
        }
      }
    }
    if (el.readonly === 1) {
      if (props.mode === 2) {
        return true;
      }
      if (props.mode === 1) {
        return true;
      } else {
        if (parseInt(userId_03) !== parseInt(props.applicant)) {
          return true;
        } else {
          return false;
        }
      }
    }
  };

  return (
    <Col
      className={'pB-20 ' + (props.el.visibility.status ? '' : ' d-none')}
      xs={12}
      md={props.el.width}
    >
      {' '}
      <Row>
        <Col xs={12}>
          <Form.Label
            className={'font-weight-bold' + (props.el.error ? 'text-danger' : '')}
            style={{ color: !props.el.error ? '#333333ff' : '', fontSize: '16px' }}
            htmlFor={props.el.name}
          >
            <span style={props.el.requiredSignal ? { display: 'inline' } : { display: 'none' }}>
              <b>* </b>
            </span>
            {props.el.label}
            <span
              className="observation-input-icon"
              style={{
                display: props.el.is_validable && props.mode === 3 ? 'inline-block' : 'none',
              }}
              onClick={() => props.setShow(props.el)}
            >
              <i
                className={'far fa-comment-dots' + (props.el.observations ? ' text-danger' : '')}
              />
            </span>
          </Form.Label>
          <DatePicker
            id={props.el.name}
            showPopperArrow={false}
            selected={startDate}
            onChange={(date) => onChangeEventHandler(date)}
            disabled={disableFieldBasedMethod(props.el)}
            locale="es"
            dateFormat="dd-MM-yyyy"
            peekNextMonth
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            placeholderText={'Selecciona una fecha'}
            customInput={
              <CustomInput
                el={props.el}
                onClear={() => {
                  setStartDate(null);
                  props.onChangeHandler(null, props.el.name, props.el.type);
                }}
              />
            }
          />
          {!props.el.error || startDate !== null ? (
            <small
              style={{ padding: '5px', fontSize: '16px', color: '#333333' }}
              id={`small${props.el.name}`}
              className="form-text mt-0"
            >
              {props.el.contextual_help ? props.el.contextual_help : ''}
            </small>
          ) : null}
          {/*    <p
            id={`warning_small${props.el.name}`}
            className={props.hasErrors ? "form-text text-danger" : ""}
            style={props.hasErrors ? { display: "block" } : { display: "none" }}
          >
            {`Necesitas establecer la fecha despues del dia ${
              props.el.extra_attributes.date.min
            }  y antes del dia  ${props.el.extra_attributes.date.max}`}
          </p>
    */}
        </Col>
      </Row>
      {!startDate ? props.errorsCalendar : null}
    </Col>
  );
};

export default DynamicDatePicker;
